import type { VulnerabilityResponse } from '@emma/api_client/types';
import { Box, Tag, Text } from '@lego/klik-ui';
import { FleetBadge } from '@/components/fleet/FleetBadge';
import { severityColorMap } from '@/components/vulnerabilities/SeverityDetails';
import { PlaceholderText } from '../../PlaceholderText';
import { createColumnHelper } from '../appTable';

const columnHelper = createColumnHelper<VulnerabilityResponse>();

export const getVulnerabilityTableColumns = (workspaceId: number) =>
  columnHelper.columns([
    columnHelper.accessor('image', {
      cell: (info) => <Text>{info.getValue()}</Text>,
      header: 'Image',
      meta: { filterVariant: { type: 'singleSearch' } },
      size: 300,
    }),
    columnHelper.accessor('fleets', {
      cell: (info) => {
        const fleets = info.getValue();

        return fleets.length > 0 ? (
          <Box display="flex" flexWrap="wrap" gap={1}>
            {fleets.map((f) => (
              <FleetBadge fleetId={f} key={f} workspaceId={workspaceId} />
            ))}
          </Box>
        ) : (
          <PlaceholderText>Unassigned</PlaceholderText>
        );
      },
      header: 'Vulnerable Fleets',
      meta: { filterVariant: { type: 'singleSearch' } },
      size: 218,
    }),
    columnHelper.accessor('findingSeverityCounts', {
      cell: (info) => {
        const severityCounts = info.getValue();
        if (!severityCounts) return <Text>N/A</Text>;

        const entries = Object.entries(severityCounts).filter(([, v]) => v && v > 0);
        if (entries.length === 0) return <Text>None</Text>;
        return (
          <Box display="flex" flexWrap="wrap" gap={1}>
            {entries.map(([severity, count]) => {
              const normalizedSeverity = severity.toUpperCase();
              return (
                <Tag
                  colorScheme={severityColorMap[normalizedSeverity] ?? 'slate'}
                  key={severity}
                  size="sm"
                >
                  {normalizedSeverity}: {count}
                </Tag>
              );
            })}
          </Box>
        );
      },
      header: 'Scan Results',
      meta: { filterVariant: { type: 'singleSearch' } },
      size: 420,
    }),
  ]);
